var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"post-added-tag",class:{ 'add-button': _vm.isAddButton}},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('img',{attrs:{"src":_vm.isAddButton ? _vm.$icons.Common.Plus : _vm.$icons.Common.Close}})])}
var staticRenderFns = []

export { render, staticRenderFns }